import { render, staticRenderFns } from "./emptyImage.vue?vue&type=template&id=7c87e26f&scoped=true&"
import script from "./emptyImage.vue?vue&type=script&lang=js&"
export * from "./emptyImage.vue?vue&type=script&lang=js&"
import style0 from "./emptyImage.vue?vue&type=style&index=0&id=7c87e26f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c87e26f",
  null
  
)

export default component.exports